import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Zap, FileText } from 'lucide-react';
export function PriceSection() {
  return <section id="offer" className="py-24 px-6 lg:px-8 bg-brand-darker text-white relative overflow-hidden" data-id="element-125">
      {/* Decorative background */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] opacity-10 pointer-events-none" data-id="element-126">
        <div className="absolute inset-0 bg-brand-accent rounded-full blur-[100px]" data-id="element-127"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-128">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-slate-800/40 backdrop-blur-md border border-slate-700 rounded-3xl p-8 md:p-12 lg:p-16 shadow-2xl" data-id="element-129">
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold mb-6" data-id="element-130">
            Empieza hoy por menos de lo que cuesta una comida rápida
          </h2>
          <p className="text-xl text-slate-300 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-131">
            Obtén la guía completa, plantillas, checklist y hoja de ruta para
            lanzar tu micro-emprendimiento digital de forma práctica y sin
            complicarte.
          </p>

          <div className="mb-10" data-id="element-132">
            <div className="flex items-center justify-center gap-2 mb-2" data-id="element-133">
              <span className="text-3xl md:text-4xl font-heading font-bold text-slate-500 line-through" data-id="element-134">
                $27 USD
              </span>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-135">
              <span className="text-6xl md:text-8xl font-heading font-extrabold text-brand-accent drop-shadow-lg" data-id="element-136">
                $7.39
              </span>
              <span className="text-2xl md:text-3xl text-brand-accent font-bold mt-4 md:mt-8" data-id="element-137">
                USD
              </span>
            </div>
          </div>

          <a href="https://www.tumundoequilibrado.com/cart/51311188541735:1" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-10 py-6 bg-brand-accent hover:bg-brand-accentHover text-white font-bold rounded-2xl text-xl md:text-2xl transition-all duration-300 transform hover:scale-105 hover:shadow-[0_0_40px_rgba(34,197,94,0.5)] flex items-center justify-center gap-3 group mx-auto mb-8 no-underline" data-id="element-138">
            Quiero acceso inmediato
            <ArrowRight className="w-7 h-7 group-hover:translate-x-1 transition-transform" data-id="element-139" />
          </a>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-slate-400 font-medium text-sm" data-id="element-140">
            <div className="flex items-center gap-2" data-id="element-141">
              <Zap className="w-5 h-5 text-brand-accent" data-id="element-142" />
              <span data-id="element-143">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-144">
              <ShieldCheck className="w-5 h-5 text-brand-accent" data-id="element-145" />
              <span data-id="element-146">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-147">
              <FileText className="w-5 h-5 text-brand-accent" data-id="element-148" />
              <span data-id="element-149">Producto digital descargable</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}